import React, { useState } from 'react';
import { Box, Card, CardHeader, CardBody, Heading, Text, Button, Flex, Icon, Badge, useToast, Divider } from '@chakra-ui/react';
import { FiAlertCircle, FiCheck, FiX } from 'react-icons/fi';
import FqClaimDetailShell from './FqClaimDetailShell';

const mockData = {
  type: '835 Denial',
  patient: { first_name: 'David', last_name: 'Kim', member_id: 'MC554433221' },
  provider: { name: 'Dr. Emily Stanton (LCSW)', npi: '3210987654' },
  claim: {
    diagnoses: ['F41.1'], // Generalized anxiety disorder
    procedures: [
      { cpt: '90834', modifiers: [], charge: 120.00 }, // Psychotherapy, 45 minutes
      { cpt: 'T1015', modifiers: [], charge: 0.00 } // Clinic visit
    ],
    clinical_note: "Patient seen for scheduled 45-minute psychotherapy session. Discussed ongoing anxiety related to work stress. Patient reports some improvement with coping strategies discussed last session. Note: Patient was seen earlier today by Dr. Chen for a physical exam."
  }
};

const FqDemoSameDayRestraint = () => {
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const toast = useToast();

  const handleAcknowledge = () => {
    setIsAcknowledged(true);
    toast({
      title: "Denial Acknowledged",
      description: "Claim marked as non-appealable. No further action required.",
      status: "info",
      duration: 5000,
      isClosable: true,
    });
  };

  const rightPanel = (
    <Card borderColor="blue.200" borderWidth="2px" shadow="md">
      <CardHeader bg="blue.50" pb={4}>
        <Flex justify="space-between" align="center">
          <Heading size="md" display="flex" alignItems="center" color="blue.800">
            <Icon as={FiAlertCircle} mr={2} />
            Revedy Analysis
          </Heading>
          <Badge colorScheme="blue" variant="solid">Tier A (Review)</Badge>
        </Flex>
      </CardHeader>
      <CardBody>
        <Box mb={4}>
          <Text fontWeight="bold" color="red.600" mb={1}>Denial Reason (CARC 97):</Text>
          <Text fontSize="sm">The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated.</Text>
        </Box>
        
        <Divider my={4} />

        <Box mb={4}>
          <Text fontWeight="bold" color="blue.700" mb={1}>Revedy Recommendation: DO NOT APPEAL</Text>
          <Text fontSize="sm" mb={2}>
            The clinical note indicates this behavioral health visit occurred on the same day as a medical visit. Under California Medi-Cal rules, a medical visit and a behavioral health visit on the same day count as a single PPS encounter.
          </Text>
        </Box>

        <Box mb={4} p={3} bg="gray.50" borderRadius="md" borderLeft="4px solid" borderLeftColor="blue.400">
          <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" mb={1}>Rule Citation:</Text>
          <Text fontSize="sm" fontStyle="italic">"A medical visit and a mental health visit occurring on the same day constitute a single FQHC/RHC encounter." (DHCS FQHC/RHC Manual)</Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" mb={1}>Proposed Action:</Text>
          <Text fontSize="sm" fontWeight="medium">Acknowledge denial. Do not append modifier 25 or 59. Do not generate an appeal, as it will be rejected.</Text>
        </Box>

        <Flex gap={3}>
          <Button 
            flex="1" 
            colorScheme="blue" 
            leftIcon={<FiCheck />} 
            onClick={handleAcknowledge}
            isDisabled={isAcknowledged}
          >
            {isAcknowledged ? 'Acknowledged' : 'Acknowledge & Close'}
          </Button>
        </Flex>
      </CardBody>
    </Card>
  );

  return <FqClaimDetailShell claimData={mockData} rightPanel={rightPanel} backTo="/fq/835-review" />;
};

export default FqDemoSameDayRestraint;